<template>
  <el-row :gutter="24" class="row_card">
    <div v-for="(payment, index) in depositChannelList" :key="`payment_${index}`">
      <el-col
        v-if="payment.isCps"
        :xs="24"
        :sm="12"
        :md="8"
        @click.native="cpsClick(payment)"
        :data-testid="convertDataTestId(payment.child[0].merchant_variable.description_title)"
      >
        <el-card class="box_card">
          <div class="row" slot="header" v-if="payment.child && payment.child.length > 0">
            <span>
              {{ langTranslate('deposit.default.channels.', payment.child[0].merchant_variable.description_title) }}
            </span>
            <ProcessTime
              :time="langTranslate('processTime.', payment.child[0].merchant_variable.deposit_processing_time)"
              :bankTime="langTranslate('processTime.', payment.child[0].merchant_variable.bank_processing_time)"
            />
          </div>
          <div class="clearfix">
            <div class="fl" v-if="payment.child && payment.child.length > 0">
              <img
                class="cps-image"
                :src="
                  paymentLogo(
                    payment.payment_method,
                    cryptoPayment.includes(payment.payment_method) ? 'ALL' : payment.child[0].actual_currency_code,
                    countryCode
                  )
                "
                alt="logo"
              />
            </div>
            <div class="fr" v-if="payment.child && payment.child.length > 0">
              <p v-if="payment.child[0].merchant_variable.fee">
                {{ payment.child[0].merchant_variable.fee }}
                {{ $t('deposit.default.fee') }}
              </p>
              <!-- <p v-if="payment.child[0].merchant_variable.processing_time">
                {{ langTranslate('deposit.time.', payment.child[0].merchant_variable.processing_time) }}
                {{ payment.child[0].merchant_variable.processing_time }}
                {{ $t('deposit.default.instant') }}
              </p> -->
              <p v-if="payment.child[0].merchant_variable.preferred">{{ $t('deposit.default.preferred') }}</p>
              <DepositCashbackTag
                v-if="
                  payment.child[0].merchant_variable.description_title === 'Cryptocurrency Deposit' &&
                  isEntitleUSDTDepositCashback
                "
              />
            </div>
          </div>
        </el-card>
      </el-col>
      <DepositCard
        v-else
        :data-testid="payment.dataTestId"
        :title="payment.title"
        :logo="payment.logo"
        :fee="payment.fee"
        :processTime="payment.processTime"
        :bankProcessTime="payment.bankProcessTime"
        :extraDesc="payment.extraDesc"
        :onClick="payment.onClick"
      />
      <!-- <el-col :xs="24" :sm="12" :md="8" @click.native="cryptoClick" data-testid="crypto">
      <el-card class="box_card">
        <div slot="header" class="row">
          <span>{{ $t('deposit.default.channels.crypto') }}</span>
          <DepositCashbackTag v-if="isEntitleUSDTDepositCashback" />
        </div>
        <div class="clearfix">
          <div class="fl">
            <div class="img_group">
              <img class="small_img" src="@/assets/images/channel/deposit_bitcoin.png" alt />
              <img class="small_img" src="@/assets/images/channel/deposit_usdt.png" alt />
            </div>
          </div>
          <div class="fr">
            <p>1 {{ $t('deposit.default.hour') }}</p>
          </div>
        </div>
      </el-card>
    </el-col> -->
    </div>
  </el-row>
</template>

<script>
import mixin from '@/mixins/deposit';
import cpsMixin from '@/mixins/cpsDeposit';
import cpsDepositListingMixin from '@/mixins/page/deposit/cpsDepositListing';
import showCreditcard from '@/mixins/page/deposit/showCreditcard';
import { countryCodeEnum } from '@/constants/country';
import { PROMOTION_TYPE } from '@/constants/promotion';
import DepositCard from '@/components/deposit/DepositCard.vue';
import ProcessTime from '@/components/ProcessTimeDeposit.vue';
import { COUNTRY_CREDIT_CARD_BLACKLIST } from '@/constants/creditCardTransfer';
import { sensorsTrack } from '@/util/sensorsdata';
import { SENSORS_TRACK } from '@/util/sensorsdata/constant';

class LocalDeposit {
  constructor({
    title,
    logo,
    onClick,
    fee = '',
    processTime = '',
    bankProcessTime = '',
    extraDesc = '',
    condition = () => true,
    dataTestId = '',
    positionIndex = null
  }) {
    // Int?
    // The position index to be inserted (included position 0)
    this.positionIndex = positionIndex ?? null;
    // Required
    this.title = title ?? '';
    this.logo = logo ?? '';
    this.onClick = onClick ?? null;
    // Optional
    this.fee = fee;
    this.processTime = processTime;
    this.bankProcessTime = bankProcessTime;
    this.extraDesc = extraDesc;
    // Extra attribute
    this.condition = condition;
    this.dataTestId = dataTestId;
    this.isCps = false;
  }
}

export default {
  components: { DepositCard, ProcessTime },
  mixins: [mixin, showCreditcard, cpsMixin, cpsDepositListingMixin],
  data() {
    return {
      cpsDepositList: [],
      localDepositList: [
        // new LocalDeposit({
        //   onClick: this.vietnamBankTransferClick,
        //   condition: () => this.countryCode === countryCodeEnum.VIETNAM,
        //   dataTestId: 'vietnamBankTransfer',
        //   title: this.$t('deposit.default.channels.vietnaminstantbanktransfer2'),
        //   logo: require('@/assets/images/channel/deposit_bank.png'),
        //   fee: `$0 ${this.$t('deposit.default.fee')}`,
        //   processTime: `${this.$t('processTime.wholeday1hour')}`,
        //   bankProcessTime: `${this.$t('processTime.within1bday247')}`
        // }),
        // new LocalDeposit({
        //   onClick: this.malaysiaClick,
        //   condition: () => this.countryCode === countryCodeEnum.MALAYSIA,
        //   dataTestId: 'malayInstant',
        //   title: this.$t('deposit.default.channels.mysInstant'),
        //   logo: require('@/assets/images/channel/vietna.png'),
        //   fee: `$0 ${this.$t('deposit.default.fee')}`,
        //   processTime: `24/7 ${this.$t('deposit.default.instant')}`
        // }),
        // new LocalDeposit({
        //   onClick: this.interacGigadatClick,
        //   condition: () => this.countryCode === countryCodeEnum.CANADA,
        //   dataTestId: 'interacGigadat',
        //   title: this.$t('deposit.default.channels.interac'),
        //   logo: require('@/assets/images/channel/deposit_interac.png'),
        //   fee: `$0 ${this.$t('deposit.default.fee')}`,
        //   processTime: `${this.$t('processTime.wholeday1hour')}`,
        //   bankProcessTime: `${this.$t('processTime.wholeday1hour')}`
        // }),
        // new LocalDeposit({
        //   onClick: this.interacClick,
        //   condition: () => this.countryCode === countryCodeEnum.CANADA,
        //   dataTestId: 'interac',
        //   title: this.$t('deposit.default.channels.interacByBanxa'),
        //   logo: require('@/assets/images/channel/deposit_interac.png'),
        //   fee: `$0 ${this.$t('deposit.default.fee')}`,
        //   processTime: `${this.$t('processTime.wholeday1hour')}`,
        //   bankProcessTime: `${this.$t('processTime.wholeday1hour')}`
        // }),
        // // new LocalDeposit({
        // //   onClick: this.japanClick,
        // //   condition: () => this.countryCode === countryCodeEnum.JAPAN,
        // //   dataTestId: 'japanBankTransfer',
        // //   title: this.$t('deposit.default.channels.japanBankTransfer'),
        // //   logo: require('@/assets/images/channel/deposit_bank.png'),
        // //   fee: `$0 ${this.$t('deposit.default.fee')}`,
        // //   processTime: `24/7 ${this.$t('deposit.default.instant')}`
        // // }),
        // new LocalDeposit({
        //   onClick: this.iDealClick,
        //   condition: () => this.countryCode === countryCodeEnum.NETHERLANDS,
        //   dataTestId: 'iDeal',
        //   title: this.$t('deposit.default.channels.dutchinstantbanktransfer'),
        //   logo: require('@/assets/images/channel/deposit_bank.png'),
        //   fee: `$0 ${this.$t('deposit.default.fee')}`,
        //   processTime: `${this.$t('processTime.wholeday1hour')}`,
        //   bankProcessTime: `${this.$t('processTime.wholeday1hour')}`
        // }),
        // new LocalDeposit({
        //   onClick: this.indiaBankTransferClick,
        //   condition: () => this.countryCode === countryCodeEnum.INDIA,
        //   dataTestId: 'indiaBankTransfer',
        //   title: this.$t('common.withdrawChannel.indiabanktransfer'),
        //   logo: require('@/assets/images/channel/deposit_bank.png'),
        //   fee: `$0 ${this.$t('deposit.default.fee')}`,
        //   processTime: `${this.$t('processTime.sixhours')}`,
        //   bankProcessTime: `${this.$t('processTime.sixhours')}`
        // }),
        // new LocalDeposit({
        //   onClick: this.myFPXClick,
        //   condition: () => this.countryCode === countryCodeEnum.MALAYSIA,
        //   dataTestId: 'malayInstant',
        //   title: this.$t('common.withdrawChannel.fpx2c2p'),
        //   logo: require('@/assets/images/channel/vietna.png'),
        //   fee: `$0 ${this.$t('deposit.default.fee')}`,
        //   processTime: `${this.$t('deposit.default.instant')}`,
        // }),
        // new LocalDeposit({
        //   onClick: this.myEWalletClick,
        //   condition: () => this.countryCode === countryCodeEnum.MALAYSIA,
        //   dataTestId: 'malayInstant',
        //   title: this.$t('deposit.default.channels.ewallet'),
        //   logo: require('@/assets/images/channel/deposit_ewallet.png'),
        //   fee: `$0 ${this.$t('deposit.default.fee')}`,
        //   processTime: `${this.$t('deposit.default.instant')}`,
        // }),
        // new LocalDeposit({
        //   onClick: this.japanP2PClick,
        //   condition: () => this.countryCode === countryCodeEnum.JAPAN,
        //   title: this.$t('common.withdrawChannel.japanlocalbankwiretransfer'),
        //   logo: require('@/assets/images/channel/vietna.png'),
        //   fee: `$0 ${this.$t('deposit.default.fee')}`,
        //   processTime: `1-3 ${this.$t('deposit.default.businessDays')}`,
        // }),
        // new LocalDeposit({
        //   onClick: this.pagsmileBrazilClick,
        //   condition: () => this.countryCode === countryCodeEnum.BRAZIL,
        //   title: this.$t('deposit.default.channels.pagsmile'),
        //   logo: require('@/assets/images/channel/deposit_bank.png'),
        //   fee: `$0* ${this.$t('deposit.default.fee')}`,
        //   processTime: `2 ${this.$t('deposit.default.hour')}`,
        //   extraDesc: 'Preferred',
        // }),
        // new LocalDeposit({
        //   onClick: this.pagsmileClick,
        //   condition: () => this.countryCode === countryCodeEnum.MEXICO,
        //   title: this.$t('common.withdrawChannel.mexicobanktransfer'),
        //   logo: require('@/assets/images/channel/deposit_bank.png'),
        //   fee: `$0* ${this.$t('deposit.default.fee')}`,
        //   processTime: `2 ${this.$t('deposit.default.hour')}`,
        //   extraDesc: 'Preferred',
        // }),
        // new LocalDeposit({
        //   onClick: this.pagsmileClick,
        //   condition: () => this.countryCode === countryCodeEnum.COLOMBIA,
        //   title: this.$t('common.withdrawChannel.colombiabanktransfer'),
        //   logo: require('@/assets/images/channel/deposit_bank.png'),
        //   fee: `$0* ${this.$t('deposit.default.fee')}`,
        //   processTime: `2 ${this.$t('deposit.default.hour')}`,
        //   extraDesc: 'Preferred',
        // }),
        // new LocalDeposit({
        //   onClick: this.pagsmileClick,
        //   condition: () => this.countryCode === countryCodeEnum.CHILE,
        //   title: this.$t('common.withdrawChannel.chilebanktransfer'),
        //   logo: require('@/assets/images/channel/deposit_bank.png'),
        //   fee: `$0* ${this.$t('deposit.default.fee')}`,
        //   processTime: `2 ${this.$t('deposit.default.hour')}`,
        //   extraDesc: 'Preferred',
        // }),
        // new LocalDeposit({
        //   onClick: this.philipinessPaymentClick,
        //   condition: () => this.countryCode === countryCodeEnum.PHILIPPINES,
        //   title: this.$t('deposit.php.header'),
        //   logo: require('@/assets/images/channel/vietna.png'),
        //   fee: `$0 ${this.$t('deposit.default.fee')}`,
        //   processTime: `24/7 ${this.$t('deposit.default.instant')}`,
        // }),
        // new LocalDeposit({
        //   onClick: this.ukClick,
        //   condition: () => this.countryCode === countryCodeEnum.UNITED_KINGDOM,
        //   title: this.$t('deposit.uk.header'),
        //   logo: require('@/assets/images/channel/uk.png'),
        //   fee: `$0 ${this.$t('deposit.default.fee')}`,
        //   processTime: `1 ${this.$t('deposit.default.businessDays')}`,
        // }),
        // new LocalDeposit({
        //   onClick: this.vietnamZotapayClick,
        //   condition: () => this.countryCode === countryCodeEnum.VIETNAM,
        //   title: this.$t('deposit.default.channels.vietInstant'),
        //   logo: require('@/assets/images/channel/vietna.png'),
        //   fee: `$0 ${this.$t('deposit.default.fee')}`,
        //   processTime: `24/7 ${this.$t('deposit.default.instant')}`,
        // }),
        // new LocalDeposit({
        //   onClick: this.laosClick,
        //   condition: () => this.countryCode === countryCodeEnum.LAOS,
        //   dataTestId: 'laos',
        //   title: this.$t('deposit.laos.header'),
        //   logo: require('@/assets/images/channel/vietna.png'),
        //   fee: `$0 ${this.$t('deposit.default.fee')}`,
        //   processTime: `24/7 ${this.$t('deposit.default.instant')}`,
        // }),
        // new LocalDeposit({
        //   onClick: this.thailandClick,
        //   condition: () =>
        //     this.countryCode === countryCodeEnum.THAILAND ||
        //     this.countryCode === countryCodeEnum.LAOS,
        //   title: this.$t('deposit.default.channels.thaiInstant'),
        //   logo: require('@/assets/images/channel/thailand.png'),
        //   fee: `$0 ${this.$t('deposit.default.fee')}`,
        //   processTime: `1 ${this.$t('deposit.default.hour')}`,
        // }),
        // new LocalDeposit({
        //   onClick: this.indiaClick,
        //   condition: () => this.countryCode === countryCodeEnum.INDIA,
        //   dataTestId: 'indiaInstant',
        //   title: this.$t('deposit.default.channels.indiaInstant'),
        //   logo: require('@/assets/images/channel/vietna.png'),
        //   fee: `$0 ${this.$t('deposit.default.fee')}`,
        //   processTime: `24/7 ${this.$t('deposit.default.instant')}`
        // }),
        // new LocalDeposit({
        //   onClick: this.dasshpeUPIClick,
        //   condition: () => this.countryCode === countryCodeEnum.INDIA,
        //   dataTestId: 'dasshpeUPI',
        //   title: this.$t('deposit.default.channels.dasshpeUPI'),
        //   logo: require('@/assets/images/channel/deposit_upi.png'),
        //   fee: `$0 ${this.$t('deposit.default.fee')}`,
        //   processTime: `24/7 ${this.$t('deposit.default.instant')}`,
        // }),
        // new LocalDeposit({
        //   onClick: this.indonesiaClick,
        //   condition: () => this.countryCode === countryCodeEnum.INDONESIA,
        //   dataTestId: 'indonesiaInstant',
        //   title: this.$t('deposit.default.channels.indoInstant'),
        //   logo: require('@/assets/images/channel/vietna.png'),
        //   fee: `$0 ${this.$t('deposit.default.fee')}`,
        //   processTime: `24/7 ${this.$t('deposit.default.instant')}`,
        // }),
        // new LocalDeposit({
        //   onClick: this.hongkongClick,
        //   condition: () => this.countryCode === countryCodeEnum.HONG_KONG,
        //   dataTestId: 'hongkong',
        //   title: this.$t('deposit.default.channels.hkBankTransfer'),
        //   logo: require('@/assets/images/channel/vietna.png'),
        //   fee: `$0 ${this.$t('deposit.default.fee')}`,
        //   processTime: `1 ${this.$t('deposit.default.hour')}`,
        // }),
        // new LocalDeposit({
        //   onClick: this.hongkongQRClick,
        //   condition: () => this.countryCode === countryCodeEnum.HONG_KONG,
        //   dataTestId: 'hongkong',
        //   title: this.$t('deposit.default.channels.hkBankTransferQR'),
        //   logo: require('@/assets/images/channel/dollarSmart.png'),
        //   fee: `$0 ${this.$t('deposit.default.fee')}`,
        //   processTime: `1 ${this.$t('deposit.default.hour')}`,
        // }),
        // new LocalDeposit({
        //   onClick: this.nigeriaClick,
        //   condition: () => this.countryCode === countryCodeEnum.NIGERIA,
        //   title: this.$t('deposit.nigeria.header'),
        //   // logo: require('@/assets/images/channel/local_banktransfer.png'),
        //   logo: require('@/assets/images/channel/deposit_bank.png'),
        //   fee: `$0 ${this.$t('deposit.default.fee')}`
        //   // processTime: `${this.$t('processTime.wholeday1hour')}`,
        //   // bankProcessTime: `${this.$t('processTime.wholeday1hour')}`
        // }),
        // new LocalDeposit({
        //   onClick: this.paystackClick,
        //   condition: () => this.countryCode === countryCodeEnum.NIGERIA,
        //   title: this.$t('deposit.default.channels.ngrLocal'),
        //   logo: require('@/assets/images/channel/local_banktransfer.png'),
        //   fee: `$0 ${this.$t('deposit.default.fee')}`,
        //   processTime: `24/7 ${this.$t('deposit.default.instant')}`,
        // }),
        // new LocalDeposit({
        //   onClick: this.euClick,
        //   condition: () =>
        //     this.notRestricted(39) && this.countryCode !== countryCodeEnum.BELGIUM,
        //   title: this.$t('deposit.eu.header'),
        //   logo: require('@/assets/images/channel/vietna.png'),
        //   fee: `$0 ${this.$t('deposit.default.fee')}`,
        //   processTime: `1-5 ${this.$t('deposit.default.businessDays')}`,
        // }),
        // new LocalDeposit({
        //   onClick: this.payablNetbankingClick,
        //   condition: () => this.EUAllowCountryfn,
        //   title: this.$t('deposit.eubank.header'),
        //   logo: require('@/assets/images/channel/vietna.png'),
        //   fee: `$0 ${this.$t('deposit.default.fee')}`,
        //   processTime: `${this.$t('processTime.b15bdays')}`,
        //   bankProcessTime: `${this.$t('processTime.b15bdays')}`
        // }),
        // new LocalDeposit({
        //   onClick: this.chinaUnionClick,
        //   condition: () => this.idPass && !this.isIsland,
        //   title: this.$t('deposit.default.channels.unionPayCN'),
        //   logo: require('@/assets/images/channel/unionpay.png'),
        //   fee: `$0 ${this.$t('deposit.default.fee')}`,
        //   processTime: `24/7 ${this.$t('deposit.default.instant')}`,
        // }),
        new LocalDeposit({
          onClick: this.creditClick,
          condition: () => this.showCC && !COUNTRY_CREDIT_CARD_BLACKLIST.includes(this.countryCode),
          dataTestId: 'creditOrDebit',
          title: this.$t('deposit.default.channels.creditOrDebitPrimary'),
          logo: require('@/assets/images/channel/visa-mastercard-logo.png'),
          fee: `$0 ${this.$t('deposit.default.fee')}`,
          processTime: `${this.$t('processTime.instant247')}`,
          bankProcessTime: `${this.$t('processTime.instant247')}`
        }),
        new LocalDeposit({
          onClick: this.appleSolidpayClick,
          condition: () => this.showAppleSolidpay && !COUNTRY_CREDIT_CARD_BLACKLIST.includes(this.countryCode),
          dataTestId: 'solidpay',
          title: this.$t('common.field.applePay'),
          logo: require('@/assets/images/channel/applePay.png'),
          fee: `$0 ${this.$t('deposit.default.fee')}`,
          processTime: `${this.$t('processTime.instant247')}`,
          bankProcessTime: `${this.$t('processTime.instant247')}`
        })
        // new LocalDeposit({
        //   onClick: this.appleGooglePayClick,
        //   condition: () => this.showAppleGooglePay,
        //   dataTestId: 'appleGooglePay',
        //   title: this.$t('deposit.default.channels.appleGooglePay'),
        //   logo: require('@/assets/images/channel/apple-google-pay.png'),
        //   fee: `$0 ${this.$t('deposit.default.fee')}`,
        //   processTime: `${this.$t('processTime.instant247')}`,
        //   bankProcessTime: `${this.$t('processTime.instant247')}`
        // }),
        // new LocalDeposit({
        //   onClick: this.googlePayClick,
        //   condition: () => this.showGooglePay,
        //   dataTestId: 'appleGooglePay',
        //   title: this.$t('deposit.default.channels.googlePay'),
        //   logo: require('@/assets/images/channel/google-pay.png'),
        //   fee: `$0 ${this.$t('deposit.default.fee')}`,
        //   processTime: `${this.$t('processTime.instant247')}`,
        //   bankProcessTime: `${this.$t('processTime.instant247')}`
        // }),
        // new LocalDeposit({
        //   onClick: this.internationalClick,
        //   condition: () => this.showIBT,
        //   dataTestId: 'i12BankTransfer',
        //   title: this.$t('deposit.default.channels.i12BankTransfer'),
        //   logo: require('@/assets/images/channel/swift.png'),
        //   fee: `$0 ${this.$t('deposit.default.fee')}`,
        //   processTime: `${this.$t('processTime.within1bday247')}`,
        //   bankProcessTime: `${this.$t('processTime.b37bdays')}`
        // })
        // new LocalDeposit({
        //   onClick: this.unionClick,
        //   condition: () => this.idPass,
        //   dataTestId: 'unionPay',
        //   title: this.$t('deposit.default.channels.unionPay'),
        //   logo: require('@/assets/images/channel/unionpay.png'),
        //   fee: `$0 ${this.$t('deposit.default.fee')}`,
        //   processTime: `24/7 ${this.$t('deposit.default.instant')}`,
        // }),
        // new LocalDeposit({
        //   onClick: this.mobileClick,
        //   condition: () => this.idPass && !this.isIsland,
        //   dataTestId: 'mobile',
        //   title: this.$t('deposit.default.channels.mobilePay'),
        //   logo: require('@/assets/images/channel/mobile.png'),
        //   fee: `$0 ${this.$t('deposit.default.fee')}`,
        //   processTime: `24/7 ${this.$t('deposit.default.instant')}`,
        // }),
        // new LocalDeposit({
        //   onClick: this.fasapayClick,
        //   condition: () => !this.isIsland,
        //   dataTestId: 'fasapay',
        //   title: this.$t('deposit.default.channels.fasa'),
        //   logo: require('@/assets/images/channel/fasapay.png'),
        //   fee: `$0 ${this.$t('deposit.default.fee')}`,
        //   processTime: `24/7 ${this.$t('deposit.default.instant')}`,
        // }),
        // new LocalDeposit({
        //   onClick: this.netellerClick,
        //   condition: () =>
        //     this.excludeEEACountries &&
        //     this.countryCode !== countryCodeEnum.VIETNAM &&
        //     !this.isIsland,
        //   dataTestId: 'neteller',
        //   title: this.$t('deposit.default.channels.neteller'),
        //   logo: require('@/assets/images/channel/neteller.png'),
        //   fee: `$0 ${this.$t('deposit.default.fee')}`,
        //   processTime: `24/7 ${this.$t('deposit.default.instant')}`,
        // }),
        // new LocalDeposit({
        //   onClick: this.skrillClick,
        //   condition: () =>
        //     this.excludeEEACountries &&
        //     this.countryCode !== countryCodeEnum.UNITED_KINGDOM &&
        //     !this.isIsland,
        //   dataTestId: 'skrill',
        //   title: this.$t('deposit.default.channels.skrill'),
        //   logo: require('@/assets/images/channel/skrill.png'),
        //   fee: `$0 ${this.$t('deposit.default.fee')}`,
        //   processTime: `24/7 ${this.$t('deposit.default.instant')}`,
        // }),
        // // cryptoClick
        // new LocalDeposit({
        //   onClick: this.dasshpeWalletClick,
        //   condition: () => this.countryCode === countryCodeEnum.INDIA,
        //   dataTestId: 'dasshpeWallet',
        //   title: this.$t('deposit.default.channels.dasshpeWallet'),
        //   logo: require('@/assets/images/channel/deposit_wallet.png'),
        //   fee: `$0 ${this.$t('deposit.default.fee')}`,
        //   processTime: `24/7 ${this.$t('deposit.default.instant')}`,
        // }),
        // new LocalDeposit({
        //   onClick: this.perfectMoneyClick,
        //   condition: () => this.excludePerfectMoneyCountries && !this.isIsland,
        //   title: this.$t('common.withdrawChannel.perfectmoney'),
        //   logo: require('@/assets/images/channel/deposit_PerfectMoney.png'),
        //   fee: `$0 ${this.$t('deposit.default.fee')}`,
        //   processTime: `24/7 ${this.$t('deposit.default.instant')}`,
        // }),
        // new LocalDeposit({
        //   onClick: this.localDepositorClick,
        //   condition: () =>
        //     this.countryCode === countryCodeEnum.MALAYSIA || this.countryCode === countryCodeEnum.INDONESIA,
        //   title: this.$t('deposit.localdepositor.depositor'),
        //   logo: require('@/assets/images/channel/deposit_LocalDepositor.png'),
        //   fee: `$0 ${this.$t('deposit.default.fee')}`,
        //   processTime: `${this.$t('processTime.wholeday1hour')}`,
        //   bankProcessTime: `${this.$t('processTime.wholeday1hour')}`
        // })
        // new LocalDeposit({
        //   onClick: this.bitwalletClick,
        //   condition: () => this.countryCode === countryCodeEnum.JAPAN,
        //   dataTestId: 'bitwallet',
        //   title: this.$t('deposit.default.channels.bitwallet'),
        //   logo: require('@/assets/images/channel/bitwallet.png'),
        //   fee: `$0 ${this.$t('deposit.default.fee')}`,
        //   processTime: `1 ${this.$t('deposit.default.businessDay')}`,
        // }),
      ],
      depositChannelList: []
    };
  },
  async mounted() {
    this.localDepositList = this.localDepositList.filter(e => e.condition());
    this.getCPSDepositChannels();
  },
  computed: {
    isEntitleUSDTDepositCashback() {
      return this.$store.state.promotion.eligibleCampaigns.findIndex(
        c => c.campaignType === PROMOTION_TYPE.USDT_DEPOSIT_CASHBACK
      ) > -1
        ? true
        : false;
    },
    isShowCpsListFirst() {
      return (
        this.countryCode === countryCodeEnum.VIETNAM ||
        this.countryCode === countryCodeEnum.MALAYSIA ||
        this.countryCode === countryCodeEnum.THAILAND ||
        this.countryCode === countryCodeEnum.CHINA ||
        this.countryCode === countryCodeEnum.HONG_KONG ||
        this.countryCode === countryCodeEnum.MACAO ||
        this.countryCode === countryCodeEnum.INDIA
      );
    },
    depositList() {
      let list = [
        ...(this.isShowCpsListFirst && this.cpsDepositList.length > 0 ? this.cpsDepositList : []),
        ...this.localDepositList,
        ...(!this.isShowCpsListFirst && this.cpsDepositList.length > 0 ? this.cpsDepositList : [])
      ];

      if (this.countryCode === countryCodeEnum.NETHERLANDS || this.countryCode === countryCodeEnum.CANADA) {
        list = this.cpsSort(list, 'T00600_083', 0);
        list = this.cpsSort(list, 'T00600_115', 1);
      }

      if (this.countryCode === countryCodeEnum.INDIA) {
        list = this.cpsSort(list, 'GT00400', 0);
        list = this.cpsSort(list, 'GIN2T00600', 1);
        list = this.localDepositSort(list, 'International bank transfer', 2);
      }

      if (this.countryCode === countryCodeEnum.JAPAN) {
        list = this.cpsSort(list, 'GJPT00600', 2);
      }

      if ([countryCodeEnum.THAILAND, countryCodeEnum.MACAO].includes(this.countryCode)) {
        //International Bank Transfer
        list = this.cpsSort(list, 'T00600_500', list.length - 1);
      }

      if (this.countryCode === countryCodeEnum.SOUTH_AFRICA) {
        list = this.cpsSort(list, 'GZAT00600', 2);
      }

      if (this.countryCode === countryCodeEnum.IRAN) {
        list = this.cpsSort(list, 'T00100_069', 0);
      }

      if (this.countryCode === countryCodeEnum.PERU) {
        list = this.cpsSort(list, 'GPET00600', 0);
      }

      if (this.countryCode === countryCodeEnum.HONG_KONG) {
        // Hong Kong Local Bank Transfer
        list = this.cpsSort(list, 'GHKT00600', 0);
      }
      if (this.countryCode === countryCodeEnum.KENYA) {
        // Kenya Instant Bank Transfer
        list = this.cpsSort(list, 'GKET00600', 0);
      }

      if (this.countryCode === countryCodeEnum.NIGERIA) {
        // Nigeria Instant Bank Transfer
        list = this.cpsSort(list, 'GNGT00600', 0);
      }

      if (this.countryCode === countryCodeEnum.GHANA) {
        // Ghana Instant Bank Transfer
        list = this.cpsSort(list, 'GGHT00600', 0);
      }
      if (this.countryCode === countryCodeEnum.ARGENTINA) {
        // Argentina Bank Transfer
        list = this.cpsSort(list, 'GART00600', 0);
      }

      list = this.cpsSort(list, 'T00600_140', 0);
      // T00100_070 AirTM(E-Wallet)
      list = this.cpsSort(list, 'T00100_070', list.length - 1);

      return list;
    }
  },
  methods: {
    cpsClick(payment) {
      if (payment && payment.child.length > 0) {
        sensorsTrack(SENSORS_TRACK.EVENT_NAME.DEPOSIT_PAGE_CLICK, {
          deposit_method: payment.child[0]?.merchant_variable?.description_title
        });
        this.$store.dispatch('cps/actionSetPayment', payment);
        this.$router.push({ name: 'cps', params: { name: payment.child[0]?.merchant_variable?.description_title } });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/pages/deposit.scss';

.crypto-cashback {
  display: inline-block;
}
</style>
